const OccupationSalary = ({locationStatistics}) => {
    return (
        <>
            {locationStatistics.isDisplayableOccupationSalary &&
                <ul className="p-knowledge_list">
                    <li className="p-knowledge_list_item">Management, business, science and arts
                        occupations: ${locationStatistics.knowledgePanelStatistics?.occupationSalaryManagement}
                    </li>
                    <li className="p-knowledge_list_item">Service occupations: ${locationStatistics.knowledgePanelStatistics?.occupationSalaryService}</li>
                    <li className="p-knowledge_list_item">Sales and office occupations: ${locationStatistics.knowledgePanelStatistics?.occupationSalarySales}</li>
                    <li className="p-knowledge_list_item">Natural resources, construction and
                        maintenance occupations: ${locationStatistics.knowledgePanelStatistics?.occupationSalaryConstruction}
                    </li>
                    <li className="p-knowledge_list_item">Production, transport and material
                        handling occupations: ${locationStatistics.knowledgePanelStatistics?.occupationSalaryTransportation}
                    </li>
                </ul>
            }
        </>
    )
}

export default OccupationSalary;
